export * from "./ThumbnailGenerator";

export interface IThumbnailGeneratorProps {
    Html: string | null;
    OnThumbnailGenerated: ((thumbnailBase64: string | null) => Promise<void>) | undefined;
    TemplateEvents: IAdvancedTemplateAppEvents;
}
